import { ChangeDetectionStrategy, Component, HostBinding, HostListener, Input } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { SpinnerHotelDirective } from '../../directives/spinner-hotel.directive';

/**
 * Component for a custom button with loading state.
 */
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'button[ctrButton], a[ctrButton]',
  imports: [MatProgressSpinnerModule, SpinnerHotelDirective, MatRippleModule],
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {
  /**
   * Whether the button is in loading state.
   */
  @Input() load = false;

  /**
   * Visual style variant of the button. Defaults to 'filled'.
   */
  @Input() variant: 'filled' | 'outlined' = 'filled';

  /**
   * Applies the outlined class to the host when variant is 'outlined'.
   */
  @HostBinding('class.btn-outlined') get isOutlined() {
    return this.variant === 'outlined';
  }

  @HostBinding('class.btn-filled') get isFilled() {
    return this.variant === 'filled';
  }

  /**
   * Prevents the default behavior of the button when it's loader.
   * @param $event
   */
  @HostListener('click', ['$event'])
  onClick($event: MouseEvent) {
    if (this.load) {
      $event.stopImmediatePropagation();
      $event.preventDefault();
      $event.stopPropagation();
    }
  }
}
